// @flow
import * as React from "react";

import { WalletOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import currencyFormatter from "utils/formatters/currency";

import type { State as AffiliateBalanceState } from "state/reducers/affiliateBalance";

type State = {
  affiliateBalance: AffiliateBalanceState,
};

type BalanceTone = "positive" | "negative" | "zero";

function getBalanceTone(balance: number): BalanceTone {
  if (balance > 0) {
    return "positive";
  }

  if (balance < 0) {
    return "negative";
  }

  return "zero";
}

function AffiliateBalance(): React.Node {
  const { value: balance, loading } = useSelector<State, AffiliateBalanceState>((state) => state.affiliateBalance);
  const tone = getBalanceTone(balance);

  return (
    <li className="nav-item AffiliateBalance d-flex align-items-center">
      <Link to="/billing/balance" className="Header-control" title="View billing">
        <span className="AffiliateBalance-icon">
          <WalletOutlined />
        </span>
        <span className="AffiliateBalance-content">
          <span className="AffiliateBalance-label">Balance</span>
          <span className={`AffiliateBalance-value${tone !== "zero" ? ` AffiliateBalance-value--${tone}` : ""}`}>
            {loading ? "—" : currencyFormatter(balance / 100)}
          </span>
        </span>
      </Link>
    </li>
  );
}

export default AffiliateBalance;
